import axios from 'axios';
import { urlAPI } from '../configurations/constantes';

class SelecaoEmpresaService {
    static obterListagemEmpresaAutocomplete = (texto) => {
        const ud = JSON.parse(localStorage.getItem('user_data'));

        return axios.get(`${urlAPI}/empresa?idUsuario=${ud.idUsuario}&role=${ud.role}&texto=${texto}`);
    };

    static obterListagemEmpresaCard = () => {
        return axios.get(`${urlAPI}/empresa/usuario`);
    };
}

export default SelecaoEmpresaService;